import feathersClient, {makeServicePlugin, BaseModel} from "@/feathers/feathers-client";
import {clearList, updateItems, addItems} from "@/vuex/feathers-vuex-plugins/custom-mutations";

class QueueDashboardWaiting extends BaseModel {

  constructor(data, options) {
    super(data, options);
  }

  static modelName = 'QueueDashboardWaiting';

}

const servicePath = 'queueDashWaiting';
const servicePlugin = makeServicePlugin({
  enableEvents: false,
  idField: 'channel',
  Model: QueueDashboardWaiting,
  service: feathersClient.service(servicePath),
  servicePath,
  mutations: {
    updateItems(state, items) {
      updateItems(state, items)
    },
    updateItem(state, item){
      updateItems(state, [item])
    },
    clearList(state){
      clearList(state)
    },
  }
});

export default servicePlugin;
